import { fetcher } from '@/config/api';

export interface FeedbackRequest {
  message_id: string;
  conversation_id: string;
  feedback_type: 'positive' | 'negative';
  comments?: string;
  include_conversation: boolean;
  allow_contact: boolean;
}

export interface FeedbackResponse {
  success: boolean;
  message: string;
  sharepoint_item_id?: string;
}

export const submitFeedback = async (data: FeedbackRequest): Promise<FeedbackResponse> => {
  return fetcher<FeedbackResponse>('/api/feedback', {
    method: 'POST',
    body: JSON.stringify(data)
  });
};
